const role = {
  SO: 'so',
  ADMIN: 'admin',
  OPERATOR: 'operator',
  AUDITOR: 'auditor'
}

export default role
